import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	viewAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAllGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	viewAll: {
		id: 'deep-dive-cards-section.view-all',
		defaultMessage: 'View all projects',
		description:
			'The text for the link for users to go to the project directory page to view all projects.',
	},
	viewAllGalaxia: {
		id: 'deep-dive-cards-section.view-all-galaxia',
		defaultMessage: 'View all spaces',
		description:
			'The text for the link for users to go to the project directory page to view all projects.',
	},
});
export default messages;
